import { ColorEnum } from '@/constants/color'
import Animated from '@/features/ui/animated'
import React, { FC } from 'react'
import { AnimatedProps } from 'react-native-reanimated'
import { Path, SvgProps } from 'react-native-svg'

type Props = Omit<AnimatedProps<SvgProps>, 'fill'> & { fill?: string }

const PowerIcon: FC<Props> = ({ fill = ColorEnum.WHITE, ...props }) => {
    return (
        <Animated.Svg viewBox="0 0 19 20" width={19} height={20} {...props}>
            <Path
                fill={fill}
                d="M9.203 10.203q-.478 0-.808-.33-.33-.328-.33-.807V1.138q0-.48.33-.809T9.203 0q.48 0 .808.33.33.328.33.808v7.928q0 .478-.33.808t-.808.33m0 9.204a8.9 8.9 0 0 1-3.59-.728 9.4 9.4 0 0 1-2.916-1.97 9.4 9.4 0 0 1-1.97-2.915A8.9 8.9 0 0 1 0 10.204q0-1.52.482-2.957a9 9 0 0 1 1.414-2.644.95.95 0 0 1 .796-.403q.49 0 .863.367a.98.98 0 0 1 .301.768 1.6 1.6 0 0 1-.29.855 6.7 6.7 0 0 0-.962 1.903 6.9 6.9 0 0 0-.329 2.11q0 2.896 2.017 4.912t4.911 2.016 4.912-2.016q2.016-2.016 2.016-4.912a7.3 7.3 0 0 0-.319-2.142 6 6 0 0 0-.997-1.915 1.5 1.5 0 0 1-.293-.823.96.96 0 0 1 .298-.756q.354-.347.845-.351a.97.97 0 0 1 .801.381 8.8 8.8 0 0 1 1.449 2.634q.492 1.428.492 2.972a8.9 8.9 0 0 1-.728 3.59 9.4 9.4 0 0 1-1.97 2.916 9.4 9.4 0 0 1-2.915 1.97 8.9 8.9 0 0 1-3.59.728"
            />
        </Animated.Svg>
    )
}

export default PowerIcon
